/**
 * machinelogic_shared.js
 *
 * Provides reusable functionality to the mm-pendant repository. If you need to export
 * visual functionality from mm-machine-logic to mm-pendant, please do it here.
 *
 */
"use strict";
(function () {
  const ui_builder_widgets = require('./views/ui_builder/uiBuilder');
  const edge_machine_app_interface = require('./machine_app/edge_machine_app_interface');
  const style_ml = require('./legacy/style');


  /* Module export glue */
  /* global define */
  const gExports = {
    renderUiPlay: ui_builder_widgets.renderUiPlay,
    edge_machine_app_interface: edge_machine_app_interface,
    style_ml: style_ml
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }

  window.components = module.exports;
}());
